import Icon from './icon.es6';

export default class Canvas {
    constructor() {
        this.$canvas = document.querySelector('.js-canvas');
        this.ctx = this.$canvas.getContext('2d');
        this._repeatAnimate = this._repeatAnimate.bind(this);

        this._createIcons();
        this._repeatAnimate();
    }

    _createIcons() {
        const width = this.$canvas.clientWidth;
        const height = this.$canvas.clientHeight;
        const num = (width * height) / 10000;

        this.$canvas.width = width;
        this.$canvas.height = height;
        this.$canvas.icons = [];

        let attempts = 0;

        while (this.$canvas.icons.length < num && attempts < 1000) {
            const icon = new Icon(width, height);

            // 衝突判定
            if (!this.$canvas.icons.some(i => i.isOverlap(icon))) {
                this.$canvas.icons.push(icon);
            }

            attempts++;
        }
    }

    _repeatAnimate() {
        this.ctx.clearRect(0, 0, this.$canvas.width, this.$canvas.height);
        this.ctx.save();

        for (const icon of this.$canvas.icons) {
            icon.draw(this.ctx);
        }

        this.ctx.restore();
        requestAnimationFrame(this._repeatAnimate);
    }

    initIcons() {
        clearTimeout(this.timer);

        this.timer = setTimeout(() => this._createIcons(), 300);
    }
}
